import { Cached } from "@mui/icons-material";
import { Autocomplete, Box, Button, Checkbox, FormControl, FormControlLabel, FormGroup, Grid, InputAdornment, InputLabel, OutlinedInput, styled, TextField, Typography } from "@mui/material"
import { ArchitecturalCode, LifeExpectancy, ProductType, Responsibility } from "../../../../../common/const";

const DefaultTypo = styled(Typography)(({ theme }) => ({
  color: 'gray',
  fontSize: 10
}));

const DefaultTypo1 = styled(Typography)(({ theme }) => ({
  color: 'red',
  fontSize: 10
}));

const Responsibilities = ({
  itemData,
  items,
  setItems,
}) => {
  return (
    <>
      <Box display="flex" justifyContent="space-between" alignItems="center">
        <Box>
          <Typography variant="body1" sx={{ fontWeight: 600 }}>Responsibility/Significant</Typography>
          <Typography variant="body2" sx={{ fontSize: 12 }}>Information related to furnish/install and architectural impact</Typography>
        </Box>
        <Box>
          <Button
            variant="outlined"
            color="primary"
            size="small"
            startIcon={<Cached />}
            onClick={() => {
              setItems((prevData) => ({
                  ...prevData,
                  product_data: {
                      ...prevData.product_data,
                      type: itemData?.product?.type,
                      life_expectancy: itemData?.product?.life_expectancy,
                      lead_time: itemData?.product?.lead_time,
                      furnish_responsibility: itemData?.product?.furnish_responsibility,
                      install_responsibility: itemData?.product?.install_responsibility,
                      architectural_code: itemData?.product?.architectural_code,
                      international: itemData?.product?.international,
                      architecturally_significant: itemData?.product?.architecturally_significant,
                      spatially_significant: itemData?.product?.spatially_significant
                  }
              }));
          }}
          >
            Reset Sections
          </Button>
        </Box>
      </Box>
      <Grid container spacing={2} mt={0.5}>
        <Grid item xs={12} sm={12} md={6} lg={3}>
          <Autocomplete
            value={ProductType.find((c) => c.value === items?.product_data?.type)}
            id="combo-box-demo"
            size="small"
            fullWidth
            options={ProductType}
            getOptionLabel={(option) => option?.name}
            onChange={(event, newValue) => {
              setItems((prevData) => ({
                ...prevData,
                product_data: {
                  ...prevData.product_data,
                  type: newValue?.value || null
                }
              }));
            }}
            renderInput={(params) => <TextField fullWidth {...params} label="Product Type" name="Product Type" variant="outlined" />}
          />
          {items?.product_data?.type !== itemData?.product?.type && (
            <Box display="flex" alignItems="center">
              <DefaultTypo variant="body2">Catalog Value:</DefaultTypo>
              <DefaultTypo1 variant="body2">{ProductType?.find((a) => a.value === itemData?.product?.type)?.name || '--'}</DefaultTypo1>
            </Box>
          )}
        </Grid>
        <Grid item xs={12} sm={12} md={6} lg={3}>
          <Autocomplete
            value={LifeExpectancy.find((c) => c.value === items?.product_data?.life_expectancy) || null}
            id="combo-box-demo"
            size="small"
            fullWidth
            options={LifeExpectancy}
            getOptionLabel={(option) => option?.name}
            onChange={(event, newValue) => {
              setItems((prevData) => ({
                ...prevData,
                product_data: {
                  ...prevData.product_data,
                  life_expectancy: newValue?.value || null,
                }
              }));
            }}
            renderInput={(params) => <TextField fullWidth {...params} label="Life Expectancy" name="Life Expectancy" variant="outlined" />}
          />
          {items?.product_data?.life_expectancy !== itemData?.product?.life_expectancy && (
            <Box display="flex" alignItems="center">
              <DefaultTypo variant="body2">Catalog Value:</DefaultTypo>
              <DefaultTypo1 variant="body2">{`${LifeExpectancy?.find((a) => a.value === itemData?.product?.life_expectancy)?.name} years` || '--'}</DefaultTypo1>
            </Box>
          )}
        </Grid>
        <Grid item xs={12} sm={12} md={6} lg={3}>
          <FormControl size="small" fullWidth variant="outlined">
            <InputLabel htmlFor="standard-adornment-password">Lead Time</InputLabel>
            <OutlinedInput
              label="Lead Time"
              id="standard-adornment-password"
              type='number'
              endAdornment={<InputAdornment position="start">Days</InputAdornment>}
              value={items?.product_data?.lead_time || ''}
              onChange={(e) => {
                setItems((prevData) => ({
                  ...prevData,
                  product_data: {
                    ...prevData.product_data,
                    lead_time: e.target.value
                  }
                }));
              }}
              onKeyDown={(event) => {
                if (event.keyCode === 38 || event.keyCode === 40) {
                  event.preventDefault();
                }
              }}
            />
          </FormControl>
          {items?.product_data?.lead_time !== itemData?.product?.lead_time && (
            <Box display="flex" alignItems="center">
              <DefaultTypo variant="body2">Catalog Value:</DefaultTypo>
              <DefaultTypo1 variant="body2">{`${itemData?.product?.lead_time} days` || '--'}</DefaultTypo1>
            </Box>
          )}
        </Grid>
        <Grid item xs={12} sm={12} md={6} lg={3}>
          <Autocomplete
            value={Responsibility.find((c) => c.value === items?.product_data?.furnish_responsibility) || null}
            id="combo-box-demo"
            size="small"
            fullWidth
            options={Responsibility}
            getOptionLabel={(option) => option?.name}
            onChange={(event, newValue) => {
              setItems((prevData) => ({
                ...prevData,
                product_data: {
                  ...prevData.product_data,
                  furnish_responsibility: newValue?.value || null,
                }
              }));
            }}
            renderInput={(params) => <TextField fullWidth {...params} label="Furnish Responsibility" name="Furnish Responsibility" variant="outlined" />}
          />
          {items?.product_data?.furnish_responsibility !== itemData?.product?.furnish_responsibility && (
            <Box display="flex" alignItems="center">
              <DefaultTypo variant="body2">Catalog Value:</DefaultTypo>
              <DefaultTypo1 variant="body2">{Responsibility.find((c) => c.value === itemData?.product?.furnish_responsibility)?.name || '--'}</DefaultTypo1>
            </Box>
          )}
        </Grid>
        <Grid item xs={12} sm={12} md={6} lg={3}>
          <Autocomplete
            value={Responsibility.find((c) => c.value === items?.product_data?.install_responsibility) || null}
            id="combo-box-demo"
            size="small"
            fullWidth
            options={Responsibility}
            getOptionLabel={(option) => option?.name}
            onChange={(event, newValue) => {
              setItems((prevData) => ({
                ...prevData,
                product_data: {
                  ...prevData.product_data,
                  install_responsibility: newValue?.value || null,
                }
              }));
            }}
            renderInput={(params) => <TextField fullWidth {...params} label="Install Responsibility" name="Install Responsibility" variant="outlined" />}
          />
          {items?.product_data?.install_responsibility !== itemData?.product?.install_responsibility && (
            <Box display="flex" alignItems="center">
              <DefaultTypo variant="body2">Catalog Value:</DefaultTypo>
              <DefaultTypo1 variant="body2">{Responsibility.find((c) => c.value === itemData?.product?.install_responsibility)?.name || '--'}</DefaultTypo1>
            </Box>
          )}
        </Grid>
        <Grid item xs={12} sm={12} md={6} lg={3}>
          <Autocomplete
            value={ArchitecturalCode.find((c) => c.value === items?.product_data?.architectural_code) || null}
            id="combo-box-demo"
            size="small"
            fullWidth
            options={ArchitecturalCode}
            getOptionLabel={(option) => option?.name}
            onChange={(event, newValue) => {
              setItems((prevData) => ({
                ...prevData,
                product_data: {
                  ...prevData.product_data,
                  architectural_code: newValue?.value || null,
                }
              }));
            }}
            renderInput={(params) => <TextField fullWidth {...params} label="Architectural Code" name="Architectural Code" variant="outlined" />}
          />
          {items?.product_data?.architectural_code !== itemData?.product?.architectural_code && (
            <Box display="flex" alignItems="center">
              <DefaultTypo variant="body2">Catalog Value:</DefaultTypo>
              <DefaultTypo1 variant="body2">{ArchitecturalCode.find((c) => c.value === itemData?.product?.architectural_code)?.name || '--'}</DefaultTypo1>
            </Box>
          )}
        </Grid>
        <Grid item xs={12} sm={6} md={3} lg={3}>
          <FormGroup>
            <FormControlLabel
              control={
                <Checkbox
                  checked={items?.product_data?.international}
                  onClick={(e) => {
                    setItems((prevData) => ({
                      ...prevData,
                      product_data: {
                        ...prevData.product_data,
                        international: e.target.checked,
                      }
                    }));
                  }}
                />}
              label="International"
            />
          </FormGroup>
          {items?.product_data?.international !== itemData?.product?.international && (
            <Box display="flex" alignItems="center">
              <DefaultTypo variant="body2">Catalog Value:</DefaultTypo>
              <DefaultTypo1 variant="body2">{itemData?.product?.international ? 'Yes' : 'No'}</DefaultTypo1>
            </Box>
          )}
        </Grid>
        <Grid item sm={12} md={6} lg={3}>
        <FormGroup>
            <FormControlLabel
              control={
                <Checkbox
                  checked={items?.product_data?.architecturally_significant}
                  onClick={(e) => {
                    setItems((prevData) => ({
                      ...prevData,
                      product_data: {
                        ...prevData.product_data,
                        architecturally_significant: e.target.checked,
                      }
                    }));
                  }}
                />}
              label="Architecturally Significant"
            />
          </FormGroup>
          {items?.product_data?.architecturally_significant !== itemData?.product?.architecturally_significant && (
            <Box display="flex" alignItems="center">
              <DefaultTypo variant="body2">Catalog Value:</DefaultTypo>
              <DefaultTypo1 variant="body2">{itemData?.product?.architecturally_significant ? 'Yes' : 'No'}</DefaultTypo1>
            </Box>
          )}
        </Grid>
        <Grid item sm={12} md={6} lg={3}>
        <FormGroup>
            <FormControlLabel
              control={
                <Checkbox
                  checked={items?.product_data?.spatially_significant}
                  onClick={(e) => {
                    setItems((prevData) => ({
                      ...prevData,
                      product_data: {
                        ...prevData.product_data,
                        spatially_significant: e.target.checked,
                      }
                    }));
                  }}
                />}
              label="Spatially Significant"
            />
          </FormGroup>
          {items?.product_data?.spatially_significant !== itemData?.product?.spatially_significant && (
            <Box display="flex" alignItems="center">
              <DefaultTypo variant="body2">Catalog Value:</DefaultTypo>
              <DefaultTypo1 variant="body2">{itemData?.product?.spatially_significant ? 'Yes' : 'No'}</DefaultTypo1>
            </Box>
          )}
        </Grid>
      </Grid>
    </>
  )
}

export default Responsibilities;